/* Maison Ronron v13 bis « ultime » : socle commun (coloris, apparitions au défilement, utilitaires).
   Chargé en premier (defer, dans <head>) ; les scripts des sections s'appuient sur window.MR14. */
(function () {
  'use strict';
  const racine = document.documentElement;
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
  racine.classList.add('js');
  if (reduit) racine.classList.add('reduit');

  // Couleurs de la toile pour chaque coloris (mêmes valeurs que snippets/mr14-donnees.liquid)
  const PALETTE = {
    noir:  { toile: '#34353b', clair: '#50515a', sombre: '#1b1b1f', couture: '#5d5e66', bord: 'none', hex: '#2b2c31' },
    kaki:  { toile: '#c8bea8', clair: '#ddd5c3', sombre: '#a69c86', couture: '#d8cfbb', bord: 'none', hex: '#c8bea8' },
    gris:  { toile: '#a6a8b0', clair: '#c3c5cb', sombre: '#84868e', couture: '#c8cad0', bord: 'none', hex: '#a6a8b0' },
    blanc: { toile: '#f2f0ea', clair: '#ffffff', sombre: '#d3d0c6', couture: '#d9d6cd', bord: '#cfccc2', hex: '#f2f0ea' },
  };

  let donnees = {};
  try { donnees = JSON.parse(document.getElementById('mr14-donnees')?.textContent || '{}'); } catch (e) { donnees = {}; }
  const ecouteurs = [];

  const MR14 = window.MR14 = {
    reduit,
    donnees,
    palette: PALETTE,
    coloris: donnees.defaut || 'noir',
    /** Infos du coloris (id, nom, variante, dispo, prix en centimes) ; par défaut le coloris choisi. */
    info(id) { return (donnees.coloris || []).find((c) => c.id === (id || MR14.coloris)) || null; },
    /** Id de la variante à ajouter au panier, ou null si le coloris choisi ne s'achète pas encore. */
    variante() { const c = MR14.info(); return c && c.dispo ? c.variante : null; },
    /** Prix formaté « 34,90 € » à partir de centimes. */
    prix(centimes) { return (Number(centimes || 0) / 100).toFixed(2).replace('.', ',') + ' €'; },
    /** Appelé à chaque changement de coloris : fn(id, info). */
    surColoris(fn) { ecouteurs.push(fn); },
    /** Change le coloris (id), avec un petit rebond sur l'élément cliqué (el, facultatif). */
    choisirColoris(id, el) {
      if (!PALETTE[id] || id === MR14.coloris) return;
      MR14.coloris = id;
      appliquer();
      ecouteurs.forEach((f) => { try { f(id, MR14.info(id)); } catch (e) { console.error(e); } });
      if (el && !reduit && el.animate) {
        el.animate([{ transform: 'scale(1)' }, { transform: 'scale(.86)', offset: .3 }, { transform: 'scale(1.1)', offset: .65 }, { transform: 'scale(1)' }],
          { duration: 520, easing: 'cubic-bezier(.23,1,.32,1)' });
      }
    },
    /** Exécute fn quand le document est prêt. */
    pret(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); },
    /** Observe des éléments une seule fois quand ils entrent à l'écran. Seuil 0 (et marge basse de 12 %) :
        un seuil en pourcentage ne serait jamais atteint par un bloc très long (texte légal sur mobile), qui resterait invisible. */
    unefois(els, fn, opts) {
      if (!('IntersectionObserver' in window)) { els.forEach((el) => fn(el)); return; }
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } }), opts || { threshold: 0, rootMargin: '0px 0px -12% 0px' });
      els.forEach((el) => io.observe(el));
    },
    /** Écouteur de défilement regroupé par requestAnimationFrame : fn() appelée au plus une fois par image. */
    auDefilement(fn) {
      let raf = 0;
      const pas = () => { raf = 0; fn(); };
      const demande = () => { if (!raf) raf = requestAnimationFrame(pas); };
      addEventListener('scroll', demande, { passive: true });
      addEventListener('resize', demande, { passive: true });
      demande();
    },
  };

  function appliquer() {
    const p = PALETTE[MR14.coloris] || PALETTE.noir;
    const b = document.body;
    if (!b) return;
    b.style.setProperty('--toile', p.toile);
    b.style.setProperty('--toile-clair', p.clair);
    b.style.setProperty('--toile-sombre', p.sombre);
    b.style.setProperty('--couture', p.couture);
    b.style.setProperty('--toile-bord', p.bord);
    b.dataset.coloris = MR14.coloris;
    const info = MR14.info();
    document.querySelectorAll('[data-mr14-coloris-nom]').forEach((e) => { e.textContent = info ? info.nom : ''; });
    document.querySelectorAll('[data-mr14-coloris-pastille]').forEach((e) => { e.style.setProperty('--c', p.hex); });
  }

  MR14.pret(() => {
    appliquer();
    // Apparitions au défilement : tout élément .revele reçoit .vu en entrant à l'écran (décalage : style="--r: 120ms")
    if ('IntersectionObserver' in window && !reduit) {
      document.body.classList.add('anime');
      MR14.unefois([...document.querySelectorAll('.revele')], (el) => el.classList.add('vu'));
    }
    // Un élément qui reçoit le focus clavier est révélé tout de suite
    document.addEventListener('focusin', (e) => e.target.closest && e.target.closest('.revele')?.classList.add('vu'));
  });
})();
